import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { usePingQuery } from "../../redux/services/crmAPI";
import { setToken, setStatus, setPermissions } from "../../redux/slices/statusSlice";

const Loading = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { data: ping } = usePingQuery("ping");

    useEffect(() => {
        if (ping) {
            localStorage.setItem("token", JSON.stringify(ping.token));
            localStorage.setItem("isLoged", JSON.stringify(ping.is_auth));

            dispatch(setToken(ping.token));
            dispatch(setStatus(ping.is_auth));
            dispatch(setPermissions(ping.permissions.map((perm) => perm.permission)));

            if (ping.is_auth) {
                navigate("/main");
            } else {
                navigate("/login");
            }
        }
    }, [ping]);
};

export default Loading;
